/**
 * @fileoverview Partner Icon View - controls UI interactions for a single partner icon in the
 * social post destinations selector
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.social.post.PartnerIconView');
goog.module.declareLegacyNamespace();

const View = goog.require('yext.mvc.View');

/**
 * @param {yext.mvc.Model} partner
 * @param {function(yext.social.post.Partner, function)} onSelect
 * @extends {View}
 * @constructor
 */
const PartnerIconView = function(partner, onSelect) {
  View.call(this);

  /** @type {yext.social.post.Partner} */
  this.model = partner;

  /** @type {!jQuery} */
  this.$el = $('<button type="button" class="' + this.model.get('iconClass') + '" + title="' + this.model.get('name') + '"/>');

  /**
   * @private
   * @param {yext.social.post.Partner} partner
   * @param {function()} onSuccess
   */
  this.onSelect_ = onSelect || function(partner, onSuccess) {
    onSuccess();
  };
};
goog.inherits(PartnerIconView, View);

/** @return this */
PartnerIconView.prototype.init = function() {
  this.render();

  this.bindSelect_();
  this.bindModelChange_();
  return this;
};

PartnerIconView.prototype.render = function() {
  this.$el.toggle(this.model.get('isAvailable'));
  this.$el.toggleClass('selected', this.model.get('isSelected'));
};

/** @private */
PartnerIconView.prototype.bindSelect_ = function() {
  this.$el.on('click', function() {
    this.onSelect_(this.model, function() {
      this.model.set('isSelected', !this.model.get('isSelected'));
    }.bind(this));
  }.bind(this));
};

/** @private */
PartnerIconView.prototype.bindModelChange_ = function() {
  this.model.on('change', function() {
    this.render();
  }.bind(this));
};

exports = PartnerIconView;
